import React, { useState, useEffect }  from "react";

/* ***********************
**   Import Material-UI
*********************** */
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

import Web3 from "web3";

/* ***********************
**   Import images
*********************** */
import logo from '../../../src/img/logofinal.png'
// import telegram from '../../../src/img/Group719.png'
// import twitter from '../../../src/img/Group720.png'
// import medium from '../../../src/img/medium.png'
// import pcs from '../../../src/img/pancakeswap.png'
// import cg from '../../../src/img/coingecko.png'
import TelegramIcon from '@material-ui/icons/Telegram';
import TwitterIcon from '@material-ui/icons/Twitter';
// import MediumIcon from '@material-ui/icons/MediumOutlined';
import Pancake from '../../img/pancakeswap.png'
import Coingeck from '../../img/coingecko.png'
import Medium from '../../img/medium(2).png'



var web3;

var accounts = [];
let finalAccount;

const Footer = () =>{
    return(
        <div className="SCB---menu">
            <Container maxWidth="lg">
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    xs={12}
                >
                    <Grid
                        xs={5}
                        sm={6}
                        style={{textAlign:'left'}}
                    >
                        <a href="/">
                            <img src={logo} style={{height:50, width: 'auto'}} />
                        </a>
                    </Grid>
                    <Grid
                        xs={7}
                        sm={6}
                        style={{textAlign:'right'}}
                    >
                        <a href='https://t.me/pcat_tokens' target="_blank" className="pcc---footer-menu-icons"><TelegramIcon style={{color:'#fdd53b'}} /></a>
              <a href='https://twitter.com/pussycatcore' target="_blank" className="pcc---footer-menu-icons"><TwitterIcon style={{color:'#fdd53b'}} /></a>
              {/* <a href='https://medium.com/@vinayk217782/2b9d93418b51' target="_blank" className="pcc---footer-menu-icons"><img src={Medium} style={{width:"27px"}}></img></a> */}
               <a href='https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x41d7ca990138dddd70aef6a66cce6cf37b478428' target="_blank" className="pcc---footer-menu-icons"><img src={Pancake} style={{width:"27px"}}></img></a>
                <a href='https://www.coingecko.com/en/coins/pcatv3' target="_blank" className="pcc---footer-menu-icons"><img src={Coingeck} style={{width:"27px"}}></img></a>
                    </Grid>

                    <Grid
                        xs={12}
                        style={{textAlign:'right'}}
                    >
                        {/* <button className="btn SCB-d-none-md" onClick={connectWallat}>{useWallet}</button> */}
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
export default Footer;